
export { LucideIcon } from "/codebuild/output/src1614243332/src/packages/shared-components/src/components/LucideIcon.tsx"